export default function RoofingFAQ() {
  const faqs = [
    {
      question: 'How much does a new roof cost in El Paso?',
      answer: 'Roofing costs in El Paso vary significantly based on materials, roof size, and complexity. Asphalt shingle roofs typically range from $5,000-$12,000 for average homes. Tile roofing runs $12,000-$25,000+. Metal roofing costs $10,000-$20,000. Factors affecting price include roof pitch, number of penetrations, removal of old materials, and material quality. Always get multiple detailed estimates.'
    },
    {
      question: 'How long does a roof last in El Paso\'s climate?',
      answer: 'El Paso\'s intense sun and temperature extremes reduce roof lifespan compared to milder climates. Quality asphalt shingles last 20-25 years, tile roofs 40-50+ years, and metal roofing 40-70 years. Proper installation, adequate ventilation, and regular maintenance significantly extend roof life. Annual inspections help catch small issues before they become major problems.'
    },
    {
      question: 'When is the best time to replace a roof in El Paso?',
      answer: 'Spring (March-May) and fall (September-November) offer ideal conditions with moderate temperatures and minimal rain. Summer\'s extreme heat can affect material installation and worker productivity, though many contractors work early mornings. Winter is generally suitable except during occasional freezes. Schedule projects 4-6 weeks in advance during peak seasons.'
    },
    {
      question: 'Do I need a permit to replace my roof in El Paso?',
      answer: 'Yes, roof replacement and major repairs require building permits from the City of El Paso. Permits ensure work meets current building codes and includes required inspections. Reputable contractors handle all permitting as part of their service. Permit costs are typically $100-$300 depending on project scope. Never skip permits—they protect your investment and home value.'
    },
    {
      question: 'How do I know if I need a roof repair or full replacement?',
      answer: 'Schedule a professional inspection to assess your roof\'s condition. Signs you need replacement include: roof age exceeding expected lifespan, widespread shingle damage, multiple leaks, sagging areas, or extensive granule loss. Repairs work for isolated damage, missing shingles, or minor leaks. A quality contractor will honestly assess whether repair or replacement is most cost-effective.'
    },
    {
      question: 'What should I do after a hailstorm in El Paso?',
      answer: 'First, document any visible damage with photos. Schedule a professional roof inspection within 30 days—most insurance policies have claim deadlines. Don\'t sign with storm chasers who knock on your door. Contact your insurance company to start a claim if damage is confirmed. Choose a local, licensed contractor with insurance claim experience to provide a detailed estimate for your adjuster.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about roofing projects in El Paso answered by local experts.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className="ri-arrow-down-s-line text-2xl text-gray-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6">
                <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center bg-teal-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Still Have Questions?
          </h3>
          <p className="text-gray-700 mb-6">
            Connect with experienced roofing contractors who can provide personalized answers for your specific situation.
          </p>
          <a href="#directory" className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Contact a Contractor
          </a>
        </div>
      </div>
    </section>
  );
}
